import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import styles from './index.scss';
import { capitalize } from 'lodash';
import { isNullOrEmpty } from '../../../../common/utils';

const { TextArea } = Input;
const { Option, OptGroup } = Select;

export const MatchingConfigName = ({
  saveMatchingConfigToStore,
  values,
  handleChange,
  reset,
  childReset,
  handleOnBlur,
  disabled,
  modulesList,
  disabledDropDown
}) => {
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({
    name: '',
    description: '',
    sourceIds: '',
    notes: ''
  });

  const onChangeHandler = (e) => {
    const { name, value, min, max } = e.target;
    handleChange(name, value);

    if (!!value && !/^[\p{L}\p{N}\p{M}]/u.test(value)) {
      setErrors({
        ...errors,
        [name]: capitalize(
          `${name} cannot start with space or special characters.`
        )
      });
    } else if (!!value && !/^[\p{L}\p{N}\p{M}\s\-_]*$/u.test(value)) {
      setErrors({
        ...errors,
        [name]: 'Supported special characters are _ - and space.'
      });
    } else if (value?.length < min || value?.length > max) {
      setErrors({
        ...errors,
        [name]: capitalize(`${name} must be ${min}-${max} characters.`)
      });
    } else {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const onChangeTextArea = (e) => {
    const { name, value } = e.target;
    handleChange(name, value);

    if (!!value && !/^[\p{L}\p{N}\p{M}]/u.test(value)) {
      setErrors({
        ...errors,
        [name]: capitalize(
          `Notes cannot start with space or special characters.`
        )
      });
    } else if (!!value && !/^[\p{L}\p{N}\p{M}\s\-_,.]*$/u.test(value)) {
      setErrors({
        ...errors,
        [name]: 'Supported special characters are _ - , . and space.'
      });
    } else if (value?.length > 1000) {
      setErrors({
        ...errors,
        [name]: `Notes must be 0-1000 characters.`
      });
    } else {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const moduleSelectHandler = (val) => {
    handleChange('sourceIds', val);
    let newData = {
      ...values,
      sourceIds: val
    };
    setErrors({
      ...errors,
      sourceIds: ''
    });
  };

  const onBlurSelectHanlder = () => {
    if (values?.sourceIds !== '')
      setErrors({
        ...errors,
        sourceIds: ''
      });
    else
      setErrors({
        ...errors,
        sourceIds: 'Please select matching configuration module.'
      });
  };

  const onBlur = (e) => {
    const { name, value, required } = e.target;
    if (value === '' && required) {
      // for Required validation
      setErrors({
        ...errors,
        [name]: `Please input matching configuration ${name}.`
      });
      handleOnBlur();
    }
  };

  useEffect(() => {
    let isValidationPassed = false;

    if (
      !isNullOrEmpty(values?.name) &&
      !isNullOrEmpty(values?.description) &&
      !isNullOrEmpty(values?.sourceIds) &&
      !Object.values(errors).some((err) => !isNullOrEmpty(err))
    ) {
      isValidationPassed = true;
    }

    if (saveMatchingConfigToStore)
      saveMatchingConfigToStore(
        'matchingConfigurationName',
        values,
        isValidationPassed
      );
  }, [values, errors]);

  useEffect(() => {
    if (reset) {
      setErrors({
        name: '',
        description: '',
        sourceIds: '',
        notes: ''
      });
      childReset(false);
    }
  }, [reset]);

  return (
    <Form className={styles.form} initialValues={values} form={form}>
      <div style={{ maxWidth: '256px', paddingTop: '24px' }}>
        <label className={(styles.label, styles.required)}>
          Matching Configuration Name
        </label>
        <Input
          name="name"
          id={'matchingConfigurationName-input'}
          title=""
          className={styles.input}
          value={values?.name}
          onChange={onChangeHandler}
          placeholder="Matching Configuration Name"
          onBlur={onBlur}
          required={true}
          min={3}
          max={100}
          disabled={disabled}
        />
        {errors.name !== '' && (
          <p className={styles.errorMessage} id="error_name">
            {errors.name}
          </p>
        )}
      </div>
      <div style={{ maxWidth: '556px' }}>
        <label className={(styles.label, styles.required)}>
          Matching Configuration Description
        </label>
        <Input
          name="description"
          id={'matchingConfigurationName-description'}
          title=""
          className={styles.input}
          value={values?.description}
          onChange={onChangeHandler}
          placeholder="Matching Configuration Description"
          onBlur={onBlur}
          required={true}
          min={3}
          max={200}
          disabled={disabled}
        />
        {errors.description !== '' && (
          <p className={styles.errorMessage} id="error_description">
            {errors.description}
          </p>
        )}
      </div>

      <div
        style={{ maxWidth: '256px', display: 'flex', flexDirection: 'column' }}>
        <label className={(styles.label, styles.required)}>Module</label>
        <Select
          placeholder="Select Module"
          value={values?.sourceIds ? values?.sourceIds : null}
          id="moduleType"
          dropdownClassName="moduleType"
          onChange={moduleSelectHandler}
          onBlur={onBlurSelectHanlder}
          disabled={disabledDropDown}>
          <OptGroup label="Select Module">
            {modulesList?.map((item, index) => (
              <Option value={item.value} key={index}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        </Select>
        {errors.sourceIds !== '' && (
          <p className={styles.errorMessage} id="error_module">
            {errors.sourceIds}
          </p>
        )}
      </div>

      <div style={{ maxWidth: '556px' }}>
        <label className={styles.label}>Notes</label>
        <TextArea
          type="text"
          id={'matchingConfigurationName-notes'}
          name="notes"
          className={styles.input}
          value={values?.notes}
          onChange={onChangeTextArea}
          placeholder="Please enter your notes here"
          rows="6"
          cols="50"
          disabled={disabled}
        />
        {errors.notes !== '' && (
          <p className={styles.errorMessage} id="error_notes">
            {errors.notes}
          </p>
        )}
      </div>
    </Form>
  );
};

export default MatchingConfigName;
